import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import { useRoute, useRouter } from "vue-router/composables";

import { ApiError } from "@/services";
import { useAuthenticationStore } from "@/stores/authentication";
import { useLanguageStore } from "@/stores/language";
import { useNotificationStore } from "@/stores/notification";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const notificationStore = useNotificationStore();
const languageStore = useLanguageStore();

const isFormValid = ref<boolean>(false);
const isPasswordVisible = ref<boolean>(false);
const password = ref<string>("");
const email = ref<string>("");
const authStore = useAuthenticationStore();

const emptyRule = (message: string) => (v: string) => !!v || message;

const router = useRouter();
const route = useRoute();
const doLogin = async () => {
  try {
    await authStore.login(email.value, password.value);
    notificationStore.addNotification({
      message: `Welcome back ${authStore.user.name}!`,
      type: "success",
    });
    await languageStore.fetchLanguages();
    let redirectPath = route.query.redirect?.toString();
    if (redirectPath) {
      await router.push({ path: redirectPath });
    } else {
      await router.push({ name: "Home" });
    }
  } catch (e: unknown) {
    const error = e as ApiError;
    let message = error.message;
    if (error.body?.detail && typeof error.body?.detail !== "object") {
      message += ": " + error.body.detail;
    }
    notificationStore.addNotification({
      message: message,
      type: "error",
    });
  }
};

return { __sfc: true,notificationStore, languageStore, isFormValid, isPasswordVisible, password, email, authStore, emptyRule, router, route, doLogin }
}

})